import { render, staticRenderFns } from "./HandlingFeesEdit.vue?vue&type=template&id=3846d9da"
import script from "./HandlingFeesEdit.vue?vue&type=script&lang=js"
export * from "./HandlingFeesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports